import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { Article, ArticleForm, Page } from "../models";

@Injectable()
export class ArticleService {

  articlesUrl = environment.dns + "api/articles/";

  constructor(private http: HttpClient) { }

  getPaginate(societyId: number, page: number, size: number): Observable<Page<Article>> {
    return this.http.get<Page<Article>>(this.articlesUrl + "paginate-by-society?societyId=" + societyId + "&page=" + page + "&size=" + size);
  }

  getListBySociety(societyId: number): Observable<Article[]> {
    return this.http.get<Article[]>(this.articlesUrl + "list-by-society?societyId=" + societyId);
  }

  getListByFamille(familleId: number): Observable<Article[]> {
    return this.http.get<Article[]>(this.articlesUrl + "list-by-famille?familleId=" + familleId);
  }

  getOne(id: number): Observable<Article> {
    return this.http.get<Article>(this.articlesUrl + id);
  }

  add(articleForm: ArticleForm): Observable<Article> {
    return this.http.post<Article>(this.articlesUrl, articleForm);
  }

  update(articleForm: ArticleForm): Observable<Article> {
    return this.http.put<Article>(this.articlesUrl, articleForm);
  }

  delete(id: number): Observable<boolean> {
    return this.http.delete<boolean>(this.articlesUrl + id);
  }
}
